<script>
import api from '@utils/api'

export default {
  name: 'DeleteItemModal',
  props: {
    itemId: {
      type: Number,
      required: true,
    },
    itemName: {
      type: String,
      default: null,
    },
    tableName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  methods: {
    deleteItem() {
      this.loading = true
      api.deleteItem(this.tableName, this.itemId).then(response => {
        this.dialog = false
        this.$emit('item-deleted')
        this.loading = false
        this.$store.dispatch('data/updateDictionary', this.tableName)
      })
    },
  },
}
</script>

<template>
  <v-layout row>
    <v-btn
      slot="activator"
      color="error"
      flat
      icon
      @click.native.stop="dialog = true">
      <v-icon>delete</v-icon>
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="355">
      <v-card>
        <v-card-title class="headline text-xs-center">
          <v-spacer />
          <div>{{ $t('titles__delete_item') }} {{ itemName }}</div>
          <v-spacer />
        </v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="loading"
            color="secondary"
            @click.native="dialog = false"
          >
            {{ $t('buttons__cancel') }}
          </v-btn>
          <v-btn
            :disabled="loading"
            :loading="loading"
            color="error"
            @click.native="deleteItem"
          >
            {{ $t('buttons__delete') }}
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
